import { Link } from 'react-router-dom';
import { hotDramas, topRatedDramas } from '@/mocks/dramas';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20atmosphere%20with%20golden%20light%20streaks%20across%20a%20dark%20theater%20setting%2C%20abstract%20bokeh%20lights%20in%20amber%20and%20warm%20tones%2C%20elegant%20dramatic%20lighting%2C%20luxurious%20velvet%20texture%20hints%2C%20movie%20premiere%20vibe%2C%20sophisticated%20entertainment%20aesthetic%2C%20rich%20contrast%20composition&width=1800&height=600&seq=cta-bg-cinema-02&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/95"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
          开启你的追剧之旅
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8">
          星空影院汇聚{hotDramas.length + topRatedDramas.length}+部精选剧集，韩剧、美剧、国产剧一网打尽，免费高清在线观看
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即追剧
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-foreground-300 hover:border-primary-500 text-foreground-700 hover:text-primary-500 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}